document.addEventListener('DOMContentLoaded', () => {
    AccordionPlugin('.faq-questions');
});
